import React, { useContext, useEffect } from "react";

import ExclusivePage from "shared/components/organisms/ExclusivePage";
import AuthContext from "shared/providers/context/AuthContext";
import GlobalContext from "shared/providers/context/GlobalContext";

interface IRouteValidation {
  entity:
    | "course"
    | "blog"
    | "bundles"
    | "collections"
    | "dashboard"
    | "media"
    | "social"
    | "users";
  children: React.ReactNode;
}

const RouteValidation = ({ entity, children }: IRouteValidation) => {
  const { state } = useContext(GlobalContext);
  const { loggedUser: user } = useContext(AuthContext);

  if (!entity)
    throw new Error("RouteValidation should receive the route entity name");

  const tenancySettings = state.tenancy?.settings;

  const entitiesConfigs = {
    course: {
      isActive: tenancySettings.courses.courseActive,
      areaAccess: tenancySettings.courses.coursesAreaAccess,
    },
    blog: {
      isActive: tenancySettings.blog.blogActive,
      areaAccess: tenancySettings.blog.blogPageAccess,
    },
    bundles: {
      isActive: tenancySettings.bundles.bundleActive,
      areaAccess: tenancySettings.bundles.bundleAreaAccess,
    },
    collections: {
      isActive: tenancySettings.collections.colletionsActive,
      areaAccess: "public",
    },
    dashboard: {
      isActive: "1",
      areaAccess: tenancySettings.dashboard.dashboardAccess,
    },
    media: {
      isActive: tenancySettings["media-space"].mediaSpaceActive,
      areaAccess: tenancySettings["media-space"].mediaSpaceAreaAccess,
    },
    social: {
      isActive: tenancySettings["social-network"].communityActive,
      areaAccess: tenancySettings["social-network"].communityAreaAccess,
    },
    users: {
      isActive: tenancySettings["social-network"].communityActive,
      areaAccess: tenancySettings["social-network"].socialNetworkAreaAccess,
    },
  };

  useEffect(() => {
    if (!entity)
      throw new Error("RouteValidation should receive the route entity name");
  }, [entity]);

  return (
    <>
      {entitiesConfigs[entity]?.isActive === "1" ? (
        entitiesConfigs[entity]?.areaAccess !== "public" && !user ? (
          <ExclusivePage />
        ) : (
          children
        )
      ) : null}
    </>
  );
};

export default RouteValidation;
